/**
 * @deprecated Prefer SSE `response_language` from API (`languageDetectionHelper`).
 * Re-export StreamLang + fallback until first progress event.
 */
export type StreamLang = 'it' | 'en' | 'es' | 'fr' | 'de' | 'pt';

/** Solo fallback iniziale prima del primo evento SSE; non usa regex duplicate. */
export function defaultStreamLanguageBeforeSse(): StreamLang {
  const nav = (navigator.language || '').slice(0, 2);
  if (nav === 'en' || nav === 'es' || nav === 'fr' || nav === 'de' || nav === 'pt' || nav === 'it') {
    return nav as StreamLang;
  }
  return 'en';
}
